export async function fetchClientID(): Promise<string> {
  
  try {
    const response = await fetch('/of2/private_services/clientid', {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const data = await response.json();
    if (data.clientid && typeof data.clientid === 'string') {
      localStorage.setItem('clientID', data.clientid);
      localStorage.setItem('clientIDTimestamp', Date.now().toString());
      sessionStorage.setItem('clientID', data.clientid);
      sessionStorage.setItem('clientIDTimestamp', Date.now().toString());
      return data.clientid;
    } else {
      throw new Error('Invalid client ID format');
    }
  } catch (e) {
    console.error("Failed to fetch client ID:", e);
    return 'unknown-client-id'; // Fallback client ID
  }
}
